// Updated App.js
import React from 'react';
import Login from './components/Login';
import SignUp from './components/SignUp';
import Chatbot from './components/Chatbot';
import ForgotPassword from './components/ForgotPassword';
import ChangePassword from './components/ChangePassword';
import Opportunity from './components/Opportunity';
import Customer from './components/Customer';
import Account from './components/Account';
import Dashboard from './components/Dashboard';
import ValuePyramid from './components/ValuePyramid';

export const routes = [
  { path: '/', element: <Login /> },
  { path: '/signup', element: <SignUp /> },
  { path: '/chatbot', element: <Chatbot /> },
  { path: '/forgotpassword', element: <ForgotPassword /> },
  { path: '/changepassword', element: <ChangePassword /> },
  { path: '/dashboard', element: <Dashboard />},
  { path: 'opportunity/:id', element: <Opportunity /> },
  { path: 'account/:id', element: <Account /> },
  { path: 'valuepyramid/:id', element: <ValuePyramid /> },
  { path: '/customer/:customer_name', element: <Customer /> },
  { path: '*', element: <div>Page not found</div> },
];

function App() {
  return <div>Your App Component</div>;
}

export default App;
